import { cssVar } from '@opallabs/gem'
import {
  DrawerSize,
  drawerSizes,
} from '@opallabs/lapidary/src/components/Drawer/types'

export const gemCopilotOpenSelector = 'gem-copilot-open'

/**
 * The width the panel opens at. It is only a default: the user can drag the
 * panel wider or narrower, so rules that make room for it must read
 * `gemPanelInlineSize` rather than this number.
 */
export const GEM_COPILOT_SIDEBAR_WIDTH = drawerSizes[DrawerSize.Wide]

/** Narrow enough to leave the monolith room on a laptop, wide enough to chat in. */
export const GEM_PANEL_MIN_WIDTH = 380

/** Past half the viewport the panel stops being a side panel. */
export const GEM_PANEL_MAX_WIDTH_RATIO = 0.5

/**
 * `body { min-width: 1150px }` in the monolith
 * (`packages/monolith/app/assets/stylesheets/global.css.scss`). The frame never
 * lays out narrower than this, so once its container is narrower the frame
 * spills past it — and a fixed-position surface inside it, like the moment
 * shroud's header, ends up under the panel.
 */
export const MONOLITH_MIN_WIDTH = 1150

export const gemPanelInlineSizeVariable = '--gem-panel-inline-size'

export const gemPanelTransitionVariable = '--gem-panel-transition'

/**
 * How long a surface takes to reach the room the panel leaves it. It drops to
 * zero while the user drags the panel's edge: the panel follows the pointer
 * immediately, so anything that animates its way to the new size falls behind
 * and shows the page through the gap.
 *
 * @note This is a duration, not a replacement for `Transition` from
 *   `@opallabs/gem`. That helper takes a `Timing` or a number of milliseconds,
 *   so it cannot hold a value the drag changes at runtime — pair the two, as
 *   `BlockDetailsPanel` does, rather than choosing between them. The 500ms
 *   fallback is the duration these surfaces already used, not a `Timing`.
 */
export const gemPanelTransition = cssVar(gemPanelTransitionVariable, '500ms')

/**
 * The panel's live width. `CopilotLayoutProvider` writes the variable on
 * `<body>`; the fallback keeps these rules correct before it mounts.
 */
export const gemPanelInlineSize = cssVar(
  gemPanelInlineSizeVariable,
  `${GEM_COPILOT_SIDEBAR_WIDTH}px`
)
